module.exports = __webpack_public_path__ + "static/media/pnlj-logo.b77ac2fe.svg";